export default {
  data() {
    return {
      statusOptions: Object.values(this.$enums.WaitingList.STATUS),
    };
  },
  computed: {
    status() {
      return '';
    },
    chipColor() {
      if (this.status) {
        return this.getChipColor(this.status);
      }

      return '';
    },
    chipText() {
      if (this.status) {
        return this.getChipText(this.status);
      }

      return '';
    },
    chipIcon() {
      if (this.status) {
        return this.getChipIcon(this.status);
      }

      return '';
    },
  },
  methods: {
    getChipColor(value) {
      switch (value) {
        case this.$enums.WaitingList.STATUS.WAITING:
          return 'warning';

        case this.$enums.WaitingList.STATUS.ACTIVE:
          return 'primary';

        case this.$enums.WaitingList.STATUS.ATTENDED:
          return 'success';

        case this.$enums.WaitingList.STATUS.CANCELED:
          return 'danger';

        default:
          return '';
      }
    },
    getChipText(value) {
      return this.$t(`$Enums.WaitingList.STATUS.${value}`);
    },
    getChipIcon(value) {
      switch (value) {
        case this.$enums.WaitingList.STATUS.WAITING:
          return 'UsersIcon';

        case this.$enums.WaitingList.STATUS.READY_NEXT:
          return 'BellIcon';

        case this.$enums.WaitingList.STATUS.ACTIVE:
          return 'UserIcon';

        case this.$enums.WaitingList.STATUS.ATTENDED:
          return 'UserCheckIcon';

        case this.$enums.WaitingList.STATUS.CANCELED:
          return 'UserXIcon';

        default:
          return '';
      }
    },
  },
};
